module.exports = __webpack_public_path__ + "img/vase.551a2854.svg";